import React from 'react';
import VoiceInteractionPicker from '@/components/SAM/VoiceInteractionPicker';
import { BackIcon } from '@/components/Onboarding/StepShell';

interface VoiceModeStepProps {
  mode: 'text' | 'voice';
  voiceGender: 'male' | 'female' | null;
  onModeChange: (m: 'text' | 'voice') => void;
  onVoiceGenderChange: (g: 'male' | 'female') => void;
  onBack: () => void;
  onFinish: () => void;
  finishing?: boolean;
  disabled?: boolean;
}

/**
 * User-onboarding step 2 — choose interaction mode (Text Only / Voice). In Voice mode the user
 * picks one of the configured voices; each card plays a sample clip (sample_url from config).
 */
const VoiceModeStep: React.FC<VoiceModeStepProps> = ({
  mode,
  voiceGender,
  onModeChange,
  onVoiceGenderChange,
  onBack,
  onFinish,
  finishing = false,
  disabled = false,
}) => {
  return (
    <div className={`bg-ui-card rounded-2xl p-8 shadow-sm ${disabled ? 'pointer-events-none opacity-60 select-none' : ''}`}>
      <h2 className="text-xl font-bold text-ui-text mb-1">Voice &amp; interaction</h2>
      <p className="text-ui-text2 text-sm mb-6">Choose how you'd like to interact with SAM.</p>

      <VoiceInteractionPicker
        mode={mode}
        voiceGender={voiceGender}
        onModeChange={onModeChange}
        onVoiceGenderChange={onVoiceGenderChange}
      />

      <div className="flex gap-3 mt-6">
        <button
          type="button"
          onClick={onBack}
          className="flex-1 border border-ui-border text-ui-text py-2.5 rounded-xl text-sm font-medium hover:bg-ui-hover transition flex items-center justify-center gap-1"
        >
          <BackIcon />
          Back
        </button>
        <button
          type="button"
          onClick={onFinish}
          disabled={finishing || (mode === 'voice' && !voiceGender)}
          className="flex-1 bg-success text-white py-2.5 rounded-xl text-sm font-medium hover:opacity-90 transition disabled:opacity-50 flex items-center justify-center gap-1.5"
        >
          {finishing ? 'Finishing…' : 'Finish Setup'}
          <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" /></svg>
        </button>
      </div>
    </div>
  );
};

export default VoiceModeStep;
